import { render, staticRenderFns } from "./IntegracionesLayout.vue?vue&type=template&id=6a5dd519&"
import script from "./IntegracionesLayout.vue?vue&type=script&lang=js&"
export * from "./IntegracionesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports